__webpack_require__.p = "https://dcs-static.gprod.postmedia.digital/21.8.0/websites/js/";